import { Box, Stack, Typography } from "@mui/material";

import { LearningMedia } from "../../../lib/learning/contentContract";
import { resolveLearningMediaUrl } from "../../../lib/learning/mediaReference";
import { borderRadius, color, space } from "../../../theme/designTokens";

type VideoBlockProps = {
  title: string;
  video: LearningMedia;
  thumbnail?: LearningMedia;
};

export const VideoBlock = ({ title, video, thumbnail }: VideoBlockProps) => (
  <Stack spacing={space.xl}>
    <Typography component="h2" variant="h5">
      {title}
    </Typography>
    <Box
      component="video"
      data-testid="learning-video"
      controls
      preload="metadata"
      poster={thumbnail ? resolveLearningMediaUrl(thumbnail.fn) : undefined}
      aria-label={title}
      sx={{ width: "100%", maxHeight: "70vh", backgroundColor: color.black, borderRadius: borderRadius.md }}
    >
      <source data-testid="learning-video-source" src={resolveLearningMediaUrl(video.fn)} />
    </Box>
  </Stack>
);
